import React from 'react';

import SiteLogo from '../../SiteLogo/SiteLogo';

import './auth-layout.less';

const AuthLayout = ({
  children,
  path,
}) => (
  <div className="auth-root">
    <div className="auth-root__wrapper">
      <div className="auth-root__banner">
        <h1>Your New Financial Portal Is Coming Soon</h1>
        <p>We're upgrading your experience with powerful new capabilities and more ways to serve you.</p>
        <p>More details coming soon.</p>
      </div>
      <img className="auth-root__image" src={`${path}`} alt="image" />

    </div>

    <div className="auth-root__content">
      <SiteLogo className="auth-root__logo" />
      {children}
    </div>
  </div>
);

export default AuthLayout;
